import { render, staticRenderFns } from "./Quick.vue?vue&type=template&id=3de774b0&"
import script from "./Quick.vue?vue&type=script&lang=js&"
export * from "./Quick.vue?vue&type=script&lang=js&"
import style0 from "./Quick.vue?vue&type=style&index=0&id=3de774b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports